<br><br>
<app-gestiones-header-preca [buttonselected]=5 [participante]="participante" [gestionSeleccionada]="gestionSeleccionada" (selecttab)="selectedtab($event)" (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
    <div class="row table-full">
        <div class="table-data" >
        <div class="table4" *ngIf="gestionSeleccionada.participante[participante].codigoSegmentoProducto === 'REMESA'">
            <table class="table table-borderless">
              <thead class="thead-light">
              <tr>
                <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th>DPI</th>
                <th>NIT</th>
                <th>SEGMENTO</th>
                <th>REGLON PRESUPUESTARIO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
                <td>{{gestionSeleccionada.participante[participante].datosGenerales.nit}}</td>
                <td>{{gestionSeleccionada.participante[participante].codigoSegmentoProducto}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.reglonPresupuestario}}</td>
              </tr>
              <tr>
                <th>PRODUCTO</th>
                <th>CATEGORÍA</th>
                <th>MINIMO</th>
                <th>MAXIMO</th>
              </tr>
              <tr>
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.nombreComercial}}
                <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.nombreCategoria}}
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.limiteInferior|
                    currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.limiteSuperior|
                    currency:"Q "}}</td>
              </tr>
              <tr>
                <th>MONTO</th>
                <th>CUOTA</th>
                <th>CUOTAS CONSOLIDADAS BANTRAB</th>
                <th>CUOTAS CONSOLIDADAS SIB EXTERNAS</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.montoAutorizado|
                  currency:"Q "}}</td>
                <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCredito|
                  currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaConsolidacionDeudasBT| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outCuotaCreditoConsolidarExterna| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>NUMERO PATRONO</th>
                <th>NOMBRE PATRONO</th>
                <th>SCORE PREDICTIVO INTERNO</th>
                <th>CATEGORÍA PATRONO</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.numeroPatrono}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.nombrePatrono}}</td>
                <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreDeudorSeleccionado|number:'1.0-0' }}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.patrono.categoriaGasto}}</td>
              </tr>
              <tr>
                <th>CODIGO EMPLEADO</th>
                <th>POSEE INDICE</th>
                <th>CLIENTE EXISTENTE</th>
                <th>FECHA DE INICIO LABORES</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.identificadorEmpleado}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">Si</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">No</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
              </tr>
              <tr>
                <th>SALARIO NOMINAL</th>
                <th>BONIFICACIÓN</th>
                <th>COMISIONES</th>
                <th>OTROS INGRESOS</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>IGSS</th>
                <th>ISR</th>
                <th>JUDICIALES</th>
                <th>OTRAS DEDUCCIONES</th>
              </tr>
              <tr>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
              </tr>
              <tr>
                <th>CUOTA INDICE</th>
                <th>SALARIO LIQUIDO</th>
                <th>SALARIO LIQUIDO BT</th>
                <th>CUOTA PENDIENTE PAGAR</th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.valorDescuentoCuotaBantrab| currency:"Q "|ReplaceText: 'Q 0.00' }}</td>
                <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='REMESA'&& gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.salarioLiquido| currency:"Q "}}</td>
                <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='REMESA' && gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">Sin indices</td>
                <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
              </tr>
              <tr>
                <th>CONTINUIDAD LABORAL</th>
                <th>SOLICITA CODEUDOR</th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
                <td *ngIf="gestionSeleccionada.participante.length==1">NO</td>
                <td *ngIf="gestionSeleccionada.participante.length==2">SI</td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
        </div>

        <div class="table4"  *ngIf="gestionSeleccionada.participante[participante].codigoSegmentoProducto === 'PAGO_VOLUNTARIO'">
            <table class="table table-borderless">
                <thead class="thead-light">
                <tr>
                  <th colspan="6" scope="col">INFORMACIÓN DE LA PRE SOLICITUD</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th>DPI</th>
                  <th>NIT</th>
                  <th>SCORE PREDICTIVO INTERNO</th>
                  <th></th>
                </tr>
                <tr>
                  <td>{{gestionSeleccionada.participante[participante].datosGenerales.dpi}}</td>
                  <td>{{gestionSeleccionada.participante[participante].datosGenerales.nit}}</td>
                  <td>{{ gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.scoreDeudorSeleccionado|number:'1.0-0' }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th>PRODUCTO</th>
                  <th>CATEGORÍA</th>
                  <th>MINIMO</th>
                  <th>MAXIMO</th>
                </tr>
                <tr>
                  <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.nombreComercial}}
                  <td >{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.nombreCategoria}}
                  <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.limiteInferior|
                      currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.limiteSuperior|
                      currency:"Q "}}</td>
                </tr>
                <tr>
                  <th>MONTO</th>
                  <th>CUOTA</th>
                  <th>CUOTAS CONSOLIDADAS BANTRAB</th>
                  <th>CUOTAS CONSOLIDADAS SIB EXTERNAS</th>
                </tr>
                <tr>
                  <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.montoAutorizado|
                    currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCredito|
                    currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.participante[this.participante].outCuotaConsolidacionDeudasBT| currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.participante[this.participante].outCuotaCreditoConsolidarExterna| currency:"Q "}}</td>
                </tr>
                <tr>
                  <th>CODIGO EMPLEADO</th>
                  <th>POSEE INDICE</th>
                  <th>CLIENTE EXISTENTE</th>
                  <th>FECHA DE INICIO LABORES</th>
                </tr>
                <tr>
                  <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.identificadorEmpleado}}</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">Si</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">No</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='E'">Si</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].outTipoCliente=='N' || gestionSeleccionada.participante[this.participante].outTipoCliente=='R' ">No</td>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.fechaInicioEmpleoActual}}</td>
                </tr>
                <tr>
                  <th>SALARIO NOMINAL</th>
                  <th>BONIFICACIÓN</th>
                  <th>COMISIONES</th>
                  <th>OTROS INGRESOS</th>
                </tr>
                <tr>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppSalarioBase| currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppBonificaciones| currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppComisiones| currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrosIngresos| currency:"Q "}}</td>
                </tr>
                <tr>
                  <th>IGSS</th>
                  <th>ISR</th>
                  <th>JUDICIALES</th>
                  <th>OTRAS DEDUCCIONES</th>
                </tr>
                <tr>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS| currency:"Q "}}</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppIGSS==''">Q 0.00</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR!=''">{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR| currency:"Q "}}</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].datosGenerales.outAppISR==''">Q 0.00</td>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.outAppDescuentosJudiciales| currency:"Q "}}</td>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.appOtrasDeducciones| currency:"Q "}}</td>
                </tr>
                <tr>
                  <th>CUOTA INDICE</th>
                  <th>SALARIO LIQUIDO</th>
                  <th>SALARIO LIQUIDO BT</th>
                  <th>CUOTA PENDIENTE PAGAR</th>
                </tr>
                <tr>
                  <td>{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.valorDescuentoCuotaBantrab| currency:"Q "|ReplaceText: 'Q 0.00' }}</td>
                  <td>{{gestionSeleccionada.participante[this.participante].outIngresoLiquido| currency:"Q "}}</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='REMESA'&& gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice=='S'">{{gestionSeleccionada.participante[this.participante].datosIndice.empleadoGobierno.salarioLiquido| currency:"Q "}}</td>
                  <td *ngIf="gestionSeleccionada.participante[this.participante].codigoSegmentoProducto=='REMESA' && gestionSeleccionada.participante[this.participante].datosIndice.patrono.indicaIndice!='S'">Sin indices</td>
                  <td>{{gestionSeleccionada.participante[this.participante].outUnaCuotaPendientePagar| currency:"Q "|ReplaceText: 'Q 0.00'}}</td>
                </tr>
                <tr>
                  <th>CONTINUIDAD LABORAL</th>
                  <th>SOLICITA CODEUDOR</th>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>{{gestionSeleccionada.participante[this.participante].datosGenerales.otroEmpleo}}</td>
                  <td *ngIf="gestionSeleccionada.participante.length==1">NO</td>
                  <td *ngIf="gestionSeleccionada.participante.length==2">SI</td>
                  <td></td>
                  <td></td>
                </tr>
                </tbody>
              </table>
        </div>

      </div>
      </div>
</div>